var $026a133d2e448375$exports = {};
$026a133d2e448375$exports = import.meta.resolve("aJu45");


const $559bf4edac46bbfa$var$registerServiceWorker = async ()=>{
    if ("serviceWorker" in navigator) try {
        const registration = await navigator.serviceWorker.register($026a133d2e448375$exports);
        if (registration.installing) console.log("Service worker installing");
        else if (registration.waiting) console.log("Service worker installed");
        else if (registration.active) console.log("Service worker active");
    } catch (error) {
        console.error(`Registration failed with ${error}`);
    }
};
$559bf4edac46bbfa$var$registerServiceWorker();


//# sourceMappingURL=diablo-2-runewords.bbcbee46.js.map
